import { render, staticRenderFns } from "./FollowerFormEvent.vue?vue&type=template&id=55f10002&scoped=true&"
import script from "./FollowerFormEvent.vue?vue&type=script&lang=js&"
export * from "./FollowerFormEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f10002",
  null
  
)

export default component.exports